<template>
  <div>
    <el-card style="margin-bottom: 10px">
      <z-search :configs="detailConfigs" v-model="searchData" @do-query="query"></z-search>
    </el-card>
    <el-card>
      <div class="mb-16">
        <el-button type="primary" @click="addPurchaseOrder" icon="el-icon-plus">
          {{ $t('purchase::purchase-list::add_supplier') }}
        </el-button>
      </div>
      <z-table
        :columns="detailsColumns"
        :data="lists"
        :max-height="550"
        :pagination.sync="pagination"
        @page-change="handlePageChange"
      >
        <template #purchaseNo="{ row }">
          <span>{{ $dataCheck(row.purchaseNo) }}</span>
          <el-progress :percentage="progress(row)" color="#70b603"></el-progress>
        </template>
        <template #spuName="{ row }">
          <p class="one-line" style="font-weight: bold">{{ row.spuName }}</p>
          <p style="font-size: 12px; color: #666666">
            <!-- {{ row.skuId }} -->
            <span v-if="row.optionValueNames">{{ row.optionValueNames.split(',').join('/') }}</span>
          </p>
        </template>
        <template #quantity="{ row }">
          <p>{{ $t('purchase::purchase-list::purchase_amount') }}：{{ row.skuBuyQuantity }}</p>
          <p style="color: #0560fd">
            {{ $t('purchase::purchase-list::arrival_amount') }}：{{ row.skuArrivalQuantity }}
          </p>
        </template>
        <!-- <template #progress="{ row }">
          <el-progress :percentage="progress(row)" color="#70b603"></el-progress>
        </template> -->
      </z-table>
    </el-card>
  </div>
</template>

<script>
import { detailConfigs, detailsColumns } from '@/views/purchase/config'
import { getPurchaseDetailList } from '@/server/purchase'
export default {
  data() {
    return {
      detailConfigs: detailConfigs(),
      detailsColumns,
      searchData: {
        searchType: 'purchaseNo',
      },
      lists: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
    }
  },
  created() {
    this.getLists()
  },
  methods: {
    query(params) {
      this.getLists(params)
    },
    addPurchaseOrder() {
      this.$router.push('/purchase/add')
    },
    handlePageChange() {
      this.getLists()
    },
    async getLists(searchData = this.searchData) {
      this.loading = true
      let params = { ...searchData }
      delete params.searchValue
      delete params.searchType
      const { data } = await getPurchaseDetailList({
        ...params,
        ...this.pagination,
      })
      this.loading = false
      if (data.code === this.$code) {
        this.lists = data.data.items
        this.pagination.total = data.data.totalCount
      }
    },
    progress(row) {
      const progress = (row.skuArrivalQuantity / row.skuBuyQuantity) * 100
      return row.skuBuyQuantity > 0 ? parseInt(progress) : 0
    },
  },
}
</script>

<style></style>
